import $ from 'jquery';

if ($('.header__wrapper').length) {
  // Toggle Search Bar Functionality
  if ($('#header-search-toggle').length) {
    const $toggleButton = $('#header-search-toggle');
    const $searchBar = $('.header__search-bar');
    const $closeButton = $('.header__search-close');

    $toggleButton.on('click', () => {
      $searchBar.fadeIn(100).toggleClass('header__search-bar--visible');
    });

    $closeButton.on('click', () => {
      $searchBar.fadeOut(100).toggleClass('header__search-bar--visible');
    });
  }

  // Nested Icons Trigger My Account Dropdown
  if ($('[data-dropdown-toggle="dropdown-toggle-account"]').length) {
    const $myAccountButton = $(
      '[data-dropdown-toggle="dropdown-toggle-account"]'
    );
    const $myAccountButtonChildren = $myAccountButton.children();

    $myAccountButtonChildren.on('click', (event) => {
      event.stopPropagation();
      $myAccountButton.trigger('click');
    });
  }
}
